/**
 * The words on the Sales Forecast Upload page that carry a decision, kept out
 * of the component file so they are unit-testable on their own.
 */

import { formatNumber } from '../../lib/format'
import type { Preview } from './api'

export const whole = (value: number | null | undefined): string =>
  formatNumber(value, { decimals: 0 })

export function versionName(fcst: string, fiscalYear: number): string {
  return `FY${String(fiscalYear)} ${fcst === 'BUD' ? 'budget (BUD)' : fcst}`
}

/** The sentence the confirm dialog exists to make someone read. */
export function consequence(preview: Preview): string {
  const total = preview.comparison?.total.proposed
  if (total === undefined || preview.fiscal_year === null) return ''
  const name = versionName(preview.fcst, preview.fiscal_year)
  const incoming = `${whole(total.lines)} lines, ${whole(total.gal)} gal`
  const current = preview.current_load
  if (current === null) return `Loads ${name} for the first time: ${incoming}.`
  return (
    `Replaces ${name} (${whole(current.lines)} lines, ${whole(current.gal)} gal, loaded ` +
    `${current.loaded_at.slice(0, 10)} by ${current.loaded_by}) with ${incoming}. ` +
    'The replaced version is archived, not deleted, and stays downloadable from the load history.'
  )
}

